import { Box, Stack, Typography } from '@mui/material'
import cls from 'classnames'
import Image from 'next/image'
import { forwardRef } from 'react'

import ArrowDownIcon from '@/assets/svgs/arrow-down.svg'
import useTrans from '@/hooks/useTrans'

import { TokenPickerViewProps } from './types'

const View = forwardRef<HTMLDivElement, TokenPickerViewProps>(
  ({ dataTestId, token, clickable = true, onClick }, ref) => {
    const trans = useTrans()

    return (
      <Box
        ref={ref}
        data-testid={dataTestId}
        onClick={clickable ? onClick : undefined}
        className={cls({
          'pl-1.5 pr-3 py-1.5': token,
          'bg-gradient-btn px-3 py-2': !token,
          'cursor-pointer': clickable,
        })}
        bgcolor={token && '#1E2735'}
        borderRadius="8px"
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className="shrink-0 grow-0"
        >
          <Stack direction="row" alignItems="center">
            {
              token ? (
                <>
                  <Box className="w-[24px]">
                    <img
                      src={token.logoURI}
                      alt={token.name}
                      className="max-w-full rounded-full w-[24px] h-[24px] object-cover"
                    />
                  </Box>
                  <Typography data-testid="selected-token-symbol" className="text-sm select-none whitespace-nowrap leading-5 font-semibold px-1.5">
                    { token.displaySymbol }
                  </Typography>
                </>
              ) : (
                <Typography data-testid="selected-token-symbol" className="text-sm select-none whitespace-nowrap leading-5 font-semibold pr-1">
                  {trans.home.select_token}
                </Typography>
              )
            }
          </Stack>
          {clickable && (
            <Image
              src={ArrowDownIcon}
              alt="ArrowDownIcon"
              className="min-w-[12px] w-3 h-3"
              data-testid="ExpandMoreIcon"
            />
          )}
        </Stack>
      </Box>
    )
  },
)

View.displayName = 'TokenPickerRevampView'
export default View
